<template>
  <div class="filter-settings">
    <div class="filter-settings__container">
      <SelectedFilter
        ref="selectedFiltersRef"
        class="filter-settings__selected"
      />
      <Dropdown
        class="filter-settings__sort"
        :selected-value="getSelectedSort(params.sort)"
        :dropdown-list="sortList"
        @on-select-value="onChangeSort"
      />
      <ButtonSecondary
        class="filter-settings__button"
        @click.prevent="onShowFilters"
      >
        <img src="~/assets/icons/filter.svg" alt="filter" />
        <p class="filter-settings__button-title">
          <span>{{ _T("@Filters") }}</span>
          <span v-if="hasItems" class="filter-settings__button-count">
            {{ items.length }}
          </span>
        </p>
      </ButtonSecondary>
    </div>
  </div>
</template>

<script setup>
import Dropdown from "~/modules/shared/dropdowns/Dropdown.vue";
import { useProductFilterStore } from "~/store/productFilter.store";
import SelectedFilter from "~/modules/productCatalog/ui/components/filter/selected/SelectedFilter.vue";
import { useAppearanceStore } from "~/store/appearanceStore";
import ButtonSecondary from "~/modules/shared/buttons/ButtonSecondary.vue";
import { useSelectedFilter } from "~/modules/productCatalog/composables/useSelectedFilter";

const filterStore = useProductFilterStore();
const { params } = storeToRefs(filterStore);
const { sideFilterMenu } = useAppearanceStore();

const { items, hasItems } = useSelectedFilter();

const sortList = [
  {
    id: 1,
    title: {
      ru: "По умолчанию",
      uk: "За замовчуванням",
    },
    value: undefined,
  },
  {
    id: 2,
    title: {
      ru: "Дешёвые",
      uk: "Дешеві",
    },
    value: "cheap",
  },
  {
    id: 3,
    title: {
      ru: "Дорогие",
      uk: "Дорогі",
    },
    value: "expensive",
  },
  {
    id: 4,
    title: {
      ru: "Популярные",
      uk: "Популярні",
    },
    value: "novelty",
  },
];

const getSelectedSort = (sort) => {
  return sortList.find(({ value }) => value === sort);
};

const onChangeSort = (sort) => {
  filterStore.changeSort(sort.value);
};

const onShowFilters = () => {
  sideFilterMenu.isShown = true;
};
</script>

<style lang="scss" scoped></style>
